/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    FilterWithShowNonEffective,
    FilterWithShowNonEffectiveFromJSON,
    FilterWithShowNonEffectiveToJSON,
    GuidIdCodeAndLabelAutocompleteResult,
    GuidIdCodeAndLabelAutocompleteResultFromJSON,
    GuidIdCodeAndLabelAutocompleteResultToJSON,
    ProblemDetails,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models';

export interface ApiStationAutocompletePostRequest {
    filterWithShowNonEffective?: FilterWithShowNonEffective;
}

/**
 * no description
 */
export class StationAutocompleteApi extends runtime.BaseAPI {

    /**
     */
    async apiStationAutocompletePostRaw(requestParameters: ApiStationAutocompletePostRequest): Promise<runtime.ApiResponse<GuidIdCodeAndLabelAutocompleteResult>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/StationAutocomplete`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FilterWithShowNonEffectiveToJSON(requestParameters.filterWithShowNonEffective),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GuidIdCodeAndLabelAutocompleteResultFromJSON(jsonValue));
    }

    /**
     */
    async apiStationAutocompletePost(requestParameters: ApiStationAutocompletePostRequest): Promise<GuidIdCodeAndLabelAutocompleteResult> {
        const response = await this.apiStationAutocompletePostRaw(requestParameters);
        return await response.value();
    }

}
